// src/app/services/breadcrumb.service.ts

import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, Observable } from 'rxjs';

export interface Breadcrumb {
  label: string;
  url: string;
  displayName: string;
}

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  get breadcrumbs$(): Observable<Breadcrumb[]> {
    return this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.createBreadcrumbs(this.activatedRoute.root))
    );
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) return breadcrumbs;

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');
      if (routeURL !== '') url += `/${routeURL}`;

      const label = child.snapshot.data['breadcrumb'];

      // Handle dynamic breadcrumb (e.g., service details)
      if (child.snapshot.params['id']) {
        breadcrumbs.push({
          label: label || 'Service Details',
          url,
          displayName: label || 'Service Details'
        });
      } else if (label) {
        breadcrumbs.push({
          label,
          url,
          displayName: label
        });
      }

      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

}
